import styled from 'styled-components/macro';
import {Link} from "react-router-dom";

import Button from "./button";
import {themecolors} from "../utils/themecolors";
import {ChevronLeft, ChevronRight} from "lucide-react";

const MaybeLink = ({ to, className, children }) =>
    to ? <Link to={to} className={className}>{children}</Link>
       : <Button className={className} disabled>{children}</Button>;
const Paginate = styled.div``;
const Previous = styled(MaybeLink)``;
const Next = styled(MaybeLink)``;

const Pagination = styled(({className, path, has_more, page, hidePrevious}) => {
    return (
        <Paginate className={className}>
            {!hidePrevious &&
                <Previous to={!page || page > 1 && `${path}${page ? page - 1 : ''}`}>
                    <ChevronLeft size={20} />
                    Previous
                </Previous>
            }
            <Next to={has_more && `${path}${page ? page+1 : ''}`}>
                Next
                <ChevronRight size={20} />
            </Next>
        </Paginate>
    );
})`
  display: flex;
  margin-top: 8px;

  ${Previous}, ${Next} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    border-radius: 48px;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Previous} svg {
    margin-right: 8px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Next} svg {
    margin-left: 8px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Previous} {
    margin-right: 8px;
    padding: 8px 20px 8px 12px;
  }
  ${Next} {
    padding: 8px 12px 8px 20px;
  }
  @media only screen and (max-width: 780px) {
    margin-left: 8px;
  }
`;

export default Pagination;
